// extracted by css-extract-rspack-plugin
export default {"whatConfusedContentTip":"what-confused-content-tip--TJWhtavL1owNFMzs"};